/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_Cep_InvalidInputs */

const en_clients_validation_cep_invalid = /** @type {(inputs: Clients_Validation_Cep_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid CEP (e.g. 12345-678).`)
};

const pt_br2_clients_validation_cep_invalid = /** @type {(inputs: Clients_Validation_Cep_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe um CEP válido (ex: 12345-678).`)
};

/**
* | output |
* | --- |
* | "Enter a valid CEP (e.g. 12345-678)." |
*
* @param {Clients_Validation_Cep_InvalidInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_cep_invalid = /** @type {((inputs?: Clients_Validation_Cep_InvalidInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Cep_InvalidInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_cep_invalid(inputs)
	return pt_br2_clients_validation_cep_invalid(inputs)
});